import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-portfolio',
  templateUrl: './nav-portfolio.component.html',
  styleUrls: ['./nav-portfolio.component.less']
})
export class NavPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
